import {ApiBase} from "./ApiBase";

export class UserBehaviorTrackerApi {
    public static trackUserBehavior(pathAndTab: string) {
        return ApiBase.processPost("/user-behavior-tracker", {pathAndTab});
    }
}